import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { listEdcQueries, updateQueryStatus } from "@/api/client";

interface EdcQueryFilters {
  studyId?: string;
  siteId?: string;
  status?: string;
  connectionIds?: string[];
  limit?: number;
  startAfter?: string;
}

export function useEdcQueries(filters?: EdcQueryFilters) {
  return useQuery({
    queryKey: ["edcQueries", filters],
    queryFn: () => listEdcQueries(filters ?? {}),
    staleTime: 2 * 60 * 1000,
  });
}

export function useUpdateQueryStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateQueryStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["edcQueries"] });
    },
  });
}
